import { Outlet,Navigate } from "react-router-dom"

const PrivateRoutes = ()  => {
    let jwtToken = localStorage.getItem("token");
  return (

    (jwtToken ? <Outlet /> : <Navigate to="/login" /> )
  )
}

export default PrivateRoutes